<template>
  <div class="sf-modal-white sf-modal sf-modal-top sf-modal-xs">
    <div class="sf-modal-backdrop">
      <div class="sf-modal-container">
        <div class="sf-modal-inner">
          <div class="sf-modal-header">
            <div class="sf-modal-back sf-invisible"></div>
            <div class="sf-modal-title">
              {{ I18n.t('user.select_existing_group') }}
            </div>
            <div class="sf-modal-close" @click="$emit('close-add-modal')"></div>
          </div>
          <form class="simple_form sf-form sf-form-full sf-pad-3">
            <div class="sf-form-select-wrapper sf-full">
              <select v-model="groupId" class="sf-form-select sf-below-1">
                <option></option>
                <option
                  v-for="group in typeaheadGroups"
                  :key="group.id"
                  :value="group.id"
                >
                  {{ group.name }}
                </option>
              </select>
            </div>
            <div class="sf-level sf-level-center">
              <div :class="saveClass" @click="submitGroup">
                {{ I18n.t('common.save') }}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/index'
import classNames from 'classnames'

const AddGroupModal = {
  props: {
    typeaheadGroups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      groupId: '',
    }
  },

  emits: ['close-add-modal', 'refresh-users'],

  computed: {
    saveClass() {
      return classNames({
        'sf-btn': true,
        'sf-btn-success': true,
        'sf-btn-disabled': !this.groupId,
      })
    },
  },

  methods: {
    submitGroup() {
      if (this.groupId) {
        api.createGroup(this.groupId).then(() => this.$emit('refresh-users'))
      }
    },
  },
}

export default AddGroupModal
</script>
